module.exports = __webpack_public_path__ + "img/404.fbd615ef.svg";